import {
    GET_SCENARIOS,
    DELETE_SCENARIO,
    UPDATE_SCENARIO,
    POST_NEW_SCENARIO,
    SCENARIO_SELECTED,
    SCENARIOS_RECEIVED,
    SET_DEFAULT_SCENARIOS,
    SET_HISTORICAL_SCENARIO,
    CLEAR_SELECTED_SCENARIO,
    GetScenariosAction,
    DeleteScenarioAction,
    UpdateScenarioAction,
    PostNewScenarioAction,
    ScenarioSelectedAction,
    ScenariosReceivedAction,
    SetDefaultScenariosAction,
    SetHistoricalSelectedScenarioAction
} from "./types";

import { createAction } from "@reduxjs/toolkit";

export const getScenarios = createAction<GetScenariosAction["payload"]>(GET_SCENARIOS);

export const scenariosReceived =
    createAction<ScenariosReceivedAction["payload"]>(SCENARIOS_RECEIVED);

export const scenarioSelected = createAction<ScenarioSelectedAction["payload"]>(SCENARIO_SELECTED);

export const setDefaultScenarios =
    createAction<SetDefaultScenariosAction["payload"]>(SET_DEFAULT_SCENARIOS);

export const postNewScenario = createAction<PostNewScenarioAction["payload"]>(POST_NEW_SCENARIO);

export const updateScenario = createAction<UpdateScenarioAction["payload"]>(UPDATE_SCENARIO);

export const setHistoricalSelectedScenario =
    createAction<SetHistoricalSelectedScenarioAction["payload"]>(SET_HISTORICAL_SCENARIO);

export const deleteScenario = createAction<DeleteScenarioAction["payload"]>(DELETE_SCENARIO);

export const clearSelectedScenario = createAction<void>(CLEAR_SELECTED_SCENARIO);
